import { render, staticRenderFns } from "./question12.vue?vue&type=template&id=0e5cd569&"
import script from "./question12.vue?vue&type=script&lang=js&"
export * from "./question12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports